module.exports = __webpack_public_path__ + "static/media/externalBarn_16.3e48c826.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/barn/externalBarn_16.png
// module id = 1304
// module chunks = 3